module.exports = __webpack_public_path__ + "img/spb-metro.6af32127.svg";